// SearchField.js
import React from 'react';
import { TextField, IconButton, Box, useTheme, InputAdornment, alpha } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

const SearchField = ({ searchQuery, handleSearchChange, ml, mr, handleClear }) => {
  const theme = useTheme();

  return (
    <Box sx={{
      mb: 2,
      maxWidth: 400,
      width: '100%',
    }}>
      <TextField
        placeholder="Αναζήτηση..."
        variant="outlined"
        value={searchQuery}
        onChange={handleSearchChange}
        size="small"
        fullWidth
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 3,
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[1],
            transition: 'all 0.3s ease-in-out',
            '&:hover': {
              boxShadow: theme.shadows[3],
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.primary.main,
                borderWidth: 1.5,
              },
              '& .MuiInputAdornment-root .MuiIconButton-root': {
                backgroundColor: 'transparent',
              },
            },
            '&.Mui-focused': {
              boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.15)}`,
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.primary.main,
                borderWidth: 2,
              },
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.divider,
              transition: 'border-color 0.3s ease-in-out',
            },
          },
          '& .MuiInputLabel-root': {
            color: theme.palette.text.secondary,
            '&.Mui-focused': {
              color: theme.palette.primary.main,
            },
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon 
                sx={{ 
                  color: searchQuery ? theme.palette.primary.main : theme.palette.text.secondary,
                  fontSize: 22,
                  transition: 'color 0.2s ease-in-out',
                }} 
              />
            </InputAdornment>
          ),
          endAdornment: searchQuery && (
            <InputAdornment position="end">
              <IconButton 
                onClick={handleClear} 
                aria-label="clear"
                size="small"
                sx={{
                  color: theme.palette.text.secondary,
                  padding: 0.5,
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    backgroundColor: alpha(theme.palette.error.main, 0.1),
                    color: theme.palette.error.main,
                    transform: 'scale(1.1)',
                  },
                }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default SearchField;
